import { useQuery } from 'hooks/useQuery'

import { fetchProgramsByIds, fetchProgramsByUserId } from 'utils/queries'

import { Program } from 'types/program'

export const usePrograms = (userId?: string, programIds?: Array<string>) => {
  return useQuery<Array<Program | null> | null>(
    ['programs', userId, programIds],
    async () => {
      if (!userId && !programIds?.length) return []

      if (userId) {
        return fetchProgramsByUserId({ userId })
      }

      if (programIds?.length) {
        return fetchProgramsByIds(programIds)
      }

      return []
    },
    {
      enabled: !!userId || !!programIds?.length,
    },
  )
}
